<template>
    <div class="bin-card-monitoring-container">
      <div class="row">
        <div class="col-lg-12 stretch-card">
          <div class="card">
  
            <!-- Body -->
            <div class="card-body">
              <!-- <h4 class="card-title">BIN Card Reports</h4> -->
              <h4 class="card-title">Detailed Aging By Principal Report</h4>
              <div class="filters">
                <div class="row mb-3">
                  <!-- Left Side -->
                  <div class="col-lg-3 col-md-3 col-12 text-left d-flex flex-column">
                    <button type="button" class="btn btn-danger dropdown-toggle btn-sm-block mt-1 ml-xl-2 ml-lg-2 ml-md-2 ml-sm-2"
                      id="dropdownMenuSizeButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <i class="fas fa-file-export"></i>
                      Upload Principal Raw File
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuSizeButton1">
                      <a class="dropdown-item" href="#" @click="uploadInitialStockingModalShow = true; uploadGuaranteedAccountModalShow = false;">Initial Stocking</a>
                      <div class="dropdown-divider"></div>
                      <a class="dropdown-item" href="#" @click="uploadGuaranteedAccountModalShow = true; uploadInitialStockingModalShow = false;">Guaranteed Account</a>
                    </div>
                    <button type="button" class="btn btn-primary btn-sm-block mt-1 ml-xl-2 ml-lg-2 ml-md-2 ml-sm-2"
                      @click="showDetailedAgingByPrincipalValidatorModal = true">
                        <i class="fas fa-download"></i>
                        Generate Detailed Aging Validator
                    </button>
                    <button type="button" class="btn btn-primary btn-sm-block mt-1 ml-xl-2 ml-lg-2 ml-md-2 ml-sm-2"
                    @click="showDetailedAgingByPrincipalDownloadTemplateModal = true">
                      <i class="fas fa-download"></i>
                      Download Template
                    </button>
                  </div>

                  <!-- Center Side -->
                  <div class="col-lg-3 col-md-3 col-12">
                  </div>
                  <div class="col-lg-3 col-md-3 col-12">
                  </div>

                  <!-- Right Side -->
                  <div class="col-lg-3 col-md-3 col-12 text-right">
                    <button type="button" class="btn btn-primary btn-sm-block mt-1 ml-xl-2 ml-lg-2 ml-md-2 ml-sm-2"
                      @click="detailedAgingByPrincipalReportModal = true">
                      <i class="fas fa-file-export"></i>
                      <!-- Generate Stock On Hand Report -->
                      Generate Detailed Aging By Principal Report
                    </button>
                  </div>
                </div>
              </div>
              <div>
                <lottie-animation style="height: 500px" :loop="true"
                  :animationData="require('@/assets/lottie/report.json')" />
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- upload modal -->
      <b-modal v-model="uploadInitialStockingModalShow" size="md" title="Detailed Aging By Principal Initial Stocking" hide-footer no-close-on-backdrop>
        <form class="forms-sample">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="txtFirstName">Raw File</label>
                <input class="form-control" type="file" v-on:change="handleInitialStockingFileUpload($event)"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <!-- <button type="button" class="btn btn-primary mr-2" @click="uploadFile"> -->
              <button type="button" class="btn btn-primary mr-2" @click="uploadFileV2('initial-stocking')">
                Upload
              </button>
              <button type="button" class="btn btn-light" @click="uploadInitialStockingModalShow = !uploadInitialStockingModalShow">
                Cancel
              </button>
            </div>
          </div>
        </form>
      </b-modal>
      <b-modal v-model="uploadGuaranteedAccountModalShow" size="md" title="Detailed Aging By Principal Guaranteed Account" hide-footer no-close-on-backdrop>
        <form class="forms-sample">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="txtFirstName">Raw File</label>
                <input class="form-control" type="file" v-on:change="handleGuaranteedAccountFileUpload($event)"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <!-- <button type="button" class="btn btn-primary mr-2" @click="uploadFile"> -->
              <button type="button" class="btn btn-primary mr-2" @click="uploadFileV2('guaranteed-account')">
                Upload
              </button>
              <button type="button" class="btn btn-light" @click="uploadGuaranteedAccountModalShow = !uploadGuaranteedAccountModalShow">
                Cancel
              </button>
            </div>
          </div>
        </form>
      </b-modal>

    <!-- detailed aging by principal validator modal -->
    <b-modal v-model="showDetailedAgingByPrincipalValidatorModal" size="md" title="Detailed Aging By Principal Validator" hide-footer
      no-close-on-backdrop>
      <form class="forms-sample">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="chkReportType">Report Type</label>
              <div class="row">
                <div class="col">
                  <div class="form-check">
                    <label class="form-check-label">
                      <input type="radio" class="form-check-input" value="initial-stocking" v-model="reportType"
                          :disabled="isGenerating" />
                          Initial Stocking
                      <i class="input-helper"></i></label>
                  </div>
                </div>
                <div class="col">
                  <div class="form-check">
                      <label class="form-check-label">
                      <input type="radio" class="form-check-input" value="guaranteed-account" v-model="reportType"
                          :disabled="isGenerating" />
                          Guaranteed Account
                      <i class="input-helper"></i></label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="txtReportDateRange">Report Date</label>
              <date-picker v-model="detailedAgingByPrincipalReportFilter.date" :clearable="false" format="MM/DD/YYYY"
                title-format="MM/DD/YYYY" time-title-format="MM/DD/YYYY" input-class="form-control"
                :input-attr="{ id: 'txtReportDateRange' }" :disabled="isGenerating" single></date-picker>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <button type="button" class="btn btn-primary mr-2" @click="generateDetailedAgingByPrincipalValidator"
              :disabled="isGenerating">
              <i class="fas fa-spinner fa-spin mr-1" v-if="isGenerating" />
              Generate
            </button>
            <button type="button" class="btn btn-light" 
              @click="
                showDetailedAgingByPrincipalValidatorModal = !showDetailedAgingByPrincipalValidatorModal
                reportType = 'initial-stocking';"
              :disabled="isGenerating">
              Cancel
            </button>
            
          </div>
        </div>
      </form>
    </b-modal>
  
    <!-- detailed aging by principal download template modal -->
    <b-modal v-model="showDetailedAgingByPrincipalDownloadTemplateModal" size="md" title="Detailed Aging By Principal Validator" hide-footer
      no-close-on-backdrop>
      <form class="forms-sample">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="chkReportType">Report Type</label>
              <div class="row">
                <div class="col">
                  <div class="form-check">
                    <label class="form-check-label">
                      <input type="radio" class="form-check-input" value="initial-stocking" v-model="reportType"
                          :disabled="isGenerating" />
                          Initial Stocking
                      <i class="input-helper"></i></label>
                  </div>
                </div>
                <div class="col">
                  <div class="form-check">
                      <label class="form-check-label">
                      <input type="radio" class="form-check-input" value="guaranteed-account" v-model="reportType"
                          :disabled="isGenerating" />
                          Guaranteed Account
                      <i class="input-helper"></i></label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <button type="button" class="btn btn-primary mr-2" @click="downloadDetailedAgingByPrincipalTemplate"
              :disabled="isGenerating">
              <i class="fas fa-spinner fa-spin mr-1" v-if="isGenerating" />
              Download
            </button>
            <button type="button" class="btn btn-light" 
              @click="
                showDetailedAgingByPrincipalDownloadTemplateModal = !showDetailedAgingByPrincipalDownloadTemplateModal
                reportType = 'initial-stocking';"
              :disabled="isGenerating">
              Cancel
            </button>
            
          </div>
        </div>
      </form>
    </b-modal>

    <!-- generate report modal -->
    <b-modal v-model="detailedAgingByPrincipalReportModal" size="md" title="Detailed Aging By Principal Report" hide-footer no-close-on-backdrop>
      <form class="forms-sample">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="chkReportType">Report Type</label>
              <div class="row">
                <div class="col">
                  <div class="form-check">
                    <label class="form-check-label">
                      <input type="radio" class="form-check-input" value="initial-stocking" v-model="reportType"
                          @click="setDate('initial-stocking')"
                          :disabled="isGenerating" />
                          Initial Stocking
                      <i class="input-helper"></i></label>
                  </div>
                </div>
                <div class="col">
                  <div class="form-check">
                      <label class="form-check-label">
                      <input type="radio" class="form-check-input" value="guaranteed-account" v-model="reportType"
                          @click="setDate('guaranteed-account')"
                          :disabled="isGenerating" />
                          Guaranteed Account
                      <i class="input-helper"></i></label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="txtReportDateRange">Report Date</label>
              <!-- <date-picker v-model="stockOnHandReportFilter.date" :clearable="false" format="MM/DD/YYYY" -->
              <date-picker v-model="detailedAgingByPrincipalReportFilter.date" :clearable="false" format="MM/DD/YYYY" 
                title-format="MM/DD/YYYY" time-title-format="MM/DD/YYYY" input-class="form-control"
                :input-attr="{ id: 'txtReportDateRange' }" :disabled="isGenerating" single></date-picker>
            </div>
          </div>
        </div>
        <div class="row" >
          <!-- v-if="reportType == 'principal'"> -->
          <div class="col">
            <div class="form-group">
              <label for="txtPrincipalCode">Principal Code</label>
              <multiselect id="txtPrincipalCode" v-model="value" placeholder="Search Principal Code" label="name"
                track-by="code" :options="principalOptions" :multiple="true"></multiselect>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-check form-check-flat form-check-primary">
              <label class="form-check-label">
                <!-- <input type="checkbox" class="form-check-input" v-model="stockOnHandReportFilter.isOfficial" -->
                <input type="checkbox" class="form-check-input" v-model="detailedAgingByPrincipalReportFilter.isOfficial"
                  :disabled="isGenerating" />
                Is Official
                <i class="input-helper"></i></label>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <button type="button" class="btn btn-primary mr-2" @click="generateDetailedAgingByPrincipalReport"
              :disabled="isGenerating">
              <i class="fas fa-spinner fa-spin mr-1" v-if="isGenerating" />
              Generate
            </button>
            <button type="button" class="btn btn-light" @click="
                          detailedAgingByPrincipalReportModal = !detailedAgingByPrincipalReportModal;
                          // reportType = 'principal';
                          reportType = 'initial-stocking';
                        " :disabled="isGenerating">
              Cancel
            </button>
          </div>
        </div>
      </form>
    </b-modal>
  
    </div>
  </template>

<script>
import { mapState } from "vuex";
import LottieAnimation from "lottie-web-vue";

export default {
    components: {
        LottieAnimation,
    },
    data() {
        return {
            value: [],
            reportType: "initial-stocking",
            reportDateRange: [new Date(), new Date()],
            // binCardReportPageItems: [],
            detailedAgingByPrincipalReportPageItems: [],
            // stockOnHandReportModal: false,
            detailedAgingByPrincipalReportModal: false,
            // uploadModalShow: false,
            showDetailedAgingByPrincipalValidatorModal: false,
            showDetailedAgingByPrincipalDownloadTemplateModal: false,
            uploadInitialStockingModalShow: false,
            uploadGuaranteedAccountModalShow: false,
            pageSize: 15,
            currentPage: 1,
            pageOfItems: [],
            isSearching: false,
            hasNoRecord: false,
            emailError: "",
            passwordError: "",
            isEdit: false,
            isGenerating: false,
            reportVersion: "2",
            file: null,
            initialStockingFile: null,
            guaranteedAccountFile: null
        };
    },
    computed: {
    ...mapState({
      principals: (state) => state.principalController.principals,
      // binCardReports: (state) => state.reportController.binCardReports,
      detailedAgingByPrincipalReports: (state) => state.reportController.detailedAgingByPrincipalReports,
      // stockOnHandReportFilter: (state) => state.reportController.stockOnHandReportFilter,
      detailedAgingByPrincipalInitialStockingLast: (state) => state.reportController.detailedAgingByPrincipalInitialStockingLast,
      detailedAgingByPrincipalGuaranteedAccountLast: (state) => state.reportController.detailedAgingByPrincipalGuaranteedAccountLast,
      detailedAgingByPrincipalReportFilter: (state) => state.reportController.detailedAgingByPrincipalReportFilter
    }),
    rows() {
      // return this.binCardReports.length;
      return this.detailedAgingByPrincipalReports.length;
    },
    principalOptions() {
      return this.principals.map((mg) => ({
        ["name"]: mg.principalCode,
        ["code"]: mg.principalCode + "-001",
      }));
    },
  },
  validations: {
    stockOnHandReportFilter: {
      // dateRange: {
      //   required,
      // },
    },
    detailedAgingByPrincipalReportFilter: {
      // dateRange: {
      //   required,
      // },
    }
  },
  watch: {
    reportType: {
      handler() {
        this.value = [];
      },
      deep: true,
    },
  },
  methods: {
    paginationChanged: function (page) {
      if (page == null) {
        page = 1;
      }

      this.detailedAgingByPrincipalReportPageItems = this.detailedAgingByPrincipalReports.slice(
        (page - 1) * this.pageSize,
        page * this.pageSize
      );
    },
    handleFileUpload(event) {
      this.file = event.target.files[0];
    },
    handleInitialStockingFileUpload(event) {
      this.initialStockingFile = event.target.files[0];
    },
    handleGuaranteedAccountFileUpload(event) {
      this.guaranteedAccountFile = event.target.files[0];
    },
    generateReport() {
      this.$toast.open({
        message: "This feature is not yet implemented.",
        type: "info",
      });
    },

    setDate(value) {
      if (value == "initial-stocking") {
        this.detailedAgingByPrincipalReportFilter.date = this.detailedAgingByPrincipalInitialStockingLast != null && this.detailedAgingByPrincipalInitialStockingLast.dateAsOf != null ?
          new Date(this.detailedAgingByPrincipalInitialStockingLast.dateAsOf) :
          new Date();
      } else if (value == "guaranteed-account"){
        this.detailedAgingByPrincipalReportFilter.date = this.detailedAgingByPrincipalGuaranteedAccountLast != null && this.detailedAgingByPrincipalGuaranteedAccountLast.dateAsOf != null ?
          new Date(this.detailedAgingByPrincipalGuaranteedAccountLast.dateAsOf) :
          new Date();
      }
    },

    async generateDetailedAgingByPrincipalReport() {
      this.$v.$touch();

      if (!this.$v.detailedAgingByPrincipalReportFilter.$invalid) {
        this.isGenerating = true;
        this.detailedAgingByPrincipalReportFilter.principalCode = this.value
          .map((mg) => mg.name)
          .join("~");

        var result = false;
        if (this.reportType == "initial-stocking") {
            result = await this.$store
                .dispatch("reportController/GetDetailedAgingByPrincipalInitialStockingReports")
                .catch(async (error) => {
                this.isGenerating = false;
                await this.$store.dispatch("showOverlay", false);
                this.$toast.open({
                    message: error.data.Message,
                    type: "error",
                });
            });
        } else if (this.reportType == "guaranteed-account"){
            result = await this.$store
                .dispatch("reportController/GetDetailedAgingByPrincipalGuaranteedAccountReports")
                .catch(async (error) => {
                this.isGenerating = false;
                await this.$store.dispatch("showOverlay", false);
                this.$toast.open({
                    message: error.data.Message,
                    type: "error",
                });
            });
        }

        if (result) {
          this.detailedAgingByPrincipalReportModal = false;
          this.reportType = "initial-stocking";
          this.isGenerating = false;
          this.value = [];

          this.$toast.open({
            message: "Report has been saved.",
            type: "success",
          });
        }
      }
    },

    async generateDetailedAgingByPrincipalValidator() {
      this.$v.$touch();

      if (!this.$v.detailedAgingByPrincipalReportFilter.$invalid) {
        this.isGenerating = true;

        var result = false;
        if (this.reportType == "initial-stocking") {
            result = await this.$store
                .dispatch("reportController/GenerateDetailedAgingByPrincipalInitialStockingValidation")
                .catch(async (error) => {
                  this.isGenerating = false;
                  await this.$store.dispatch("showOverlay", false);
                  console.log(error);
                  this.$toast.open({
                    message: error.data.Message,
                    type: "error",
                  });
              });
        } else if (this.reportType == "guaranteed-account"){
            result = await this.$store
                .dispatch("reportController/GenerateDetailedAgingByPrincipalGuaranteedAccountValidation")
                .catch(async (error) => {
                this.isGenerating = false;
                await this.$store.dispatch("showOverlay", false);
                this.$toast.open({
                    message: error.data.Message,
                    type: "error",
                });
            });
        } 

        if (result) {
          this.showDetailedAgingByPrincipalValidatorModal = false;
          this.reportType = "initial-stocking";
          this.isGenerating = false;
          this.value = [];

          this.$toast.open({
            message: "Report has been saved.",
            type: "success",
          });
        }
      }
    },

    async uploadFileV2(targetType) {
        var result = false;
        
        if (targetType == "initial-stocking") {
            await this.$store.dispatch("showOverlay", true);
            result = await this.$store
              .dispatch("reportController/UploadDetailedAgingByPrincipalInitialStockingReports", this.initialStockingFile)
              .catch(async (error) => {
                  await this.$store.dispatch("showOverlay", false);
                  this.$toast.open({
                    message: error.data.Message,
                    type: "error",
                  });
              });
        } else if (targetType == "guaranteed-account"){
            await this.$store.dispatch("showOverlay", true);
            result = await this.$store
                .dispatch("reportController/UploadDetailedAgingByPrincipalGuaranteedAccountReports", this.guaranteedAccountFile)
                .catch(async (error) => {
                this.isGenerating = false;
                await this.$store.dispatch("showOverlay", false);
                this.$toast.open({
                    message: error.data.Message,
                    type: "error",
                });
            });
        }

      if (result) {
        await this.searchFilter();
        await this.$store.dispatch("showOverlay", false);
        this.uploadInitialStockingModalShow = false;
        this.uploadGuaranteedAccountModalShow = false;
        this.$toast.open({
          message: "Report has been uploaded.",
          type: "success",
        });
      }
    },

    async downloadDetailedAgingByPrincipalTemplate() {
      this.isGenerating = true;

      var result = false;
      if (this.reportType == "initial-stocking") {
          result = await this.$store
              .dispatch("reportController/GetDetailedAgingByPrincipalInitialStocking_Template")
              .catch(async (error) => {
                this.isGenerating = false;
                await this.$store.dispatch("showOverlay", false);
                console.log(error);
                this.$toast.open({
                  message: error.data.Message,
                  type: "error",
                });
            });
      } else if (this.reportType == "guaranteed-account"){
          result = await this.$store
              .dispatch("reportController/GetDetailedAgingByPrincipalGuaranteedAccount_Template")
              .catch(async (error) => {
              this.isGenerating = false;
              await this.$store.dispatch("showOverlay", false);
              this.$toast.open({
                  message: error.data.Message,
                  type: "error",
              });
          });
      } 

      if (result) {
        this.showDetailedAgingByPrincipalDownloadTemplateModal = false;
        this.reportType = "initial-stocking";
        this.isGenerating = false;
        this.value = [];

        this.$toast.open({
          message: "Report has been saved.",
          type: "success",
        });
      }
    },

    searchFilter: async function () {
      this.currentPage = 1;
      this.pageOfItems = [];
      this.isSearching = true;
      this.hasNoRecord = false;
      this.paginationChanged();
      this.isSearching = false;

      if (this.detailedAgingByPrincipalReports.length == 0) {
          this.hasNoRecord = true;
      }
    },
  },
  async mounted() {
    await this.searchFilter();
    await this.$store
        .dispatch("reportController/GetDetailedAgingByPrincipalInitialStockingLast_Date")
        .catch((error) => {
          this.isSearching = false;
        });
    await this.$store
        .dispatch("reportController/GetDetailedAgingByPrincipalGuaranteedAccountLast_Date")
        .catch((error) => {
          this.isSearching = false;
        });
    
    this.setDate(this.reportType);
  },
};
</script>

<style scoped>
.mx-datepicker-range {
  width: 100%;
}
</style>